import { render, staticRenderFns } from "./IpmStandardsPage.vue?vue&type=template&id=36bbd376&scoped=true&"
import script from "./IpmStandardsPage.vue?vue&type=script&lang=js&"
export * from "./IpmStandardsPage.vue?vue&type=script&lang=js&"
import style0 from "./IpmStandardsPage.vue?vue&type=style&index=0&id=36bbd376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bbd376",
  null
  
)

export default component.exports